export default function() {
  return this._root;
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/d3-force/node_modules/d3-quadtree/src/root.js
// module id = 612
// module chunks = 0